export const theme = {
    colors: {
        primaryDark: "#0F1020",
        primaryLight: "#FFFFFF",
        accentPurple: "#E8D5FF",
        accentGreen: "#D1FAE5",
        accentPeach: "#FED7AA",
        accentPink: "#FBCFE8",
        accentBlue: "#DBEAFE",
        accentYellow: "#FEF3C7",
        textPrimary: "#111827",
        textSecondary: "#6B7280",
        textLight: "#9CA3AF",
        success: "#10B981",
        warning: "#F59E0B",
        danger: "#EF4444",
        info: "#3B82F6",
        borderLight: "#E5E7EB",
        borderMedium: "#D1D5DB",
        gradientPrimary: "linear-gradient(180deg, #0F1020 0%, #1A1B2E 100%)",
    },

    typography: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        h1: { fontSize: "28px", fontWeight: 700, lineHeight: 1.2 },
        h2: { fontSize: "24px", fontWeight: 600, lineHeight: 1.3 },
        h3: { fontSize: "20px", fontWeight: 600, lineHeight: 1.4 },
        body1: { fontSize: "16px", fontWeight: 400, lineHeight: 1.5 },
        body2: { fontSize: "14px", fontWeight: 400, lineHeight: 1.5 },
        caption: { fontSize: "12px", fontWeight: 400, lineHeight: 1.4 },
        number: { fontSize: "32px", fontWeight: 700, lineHeight: 1.2 },
    },

    shadows: {
        card: "0 10px 30px rgba(0, 0, 0, 0.04)",
        sidebar: "4px 0 15px rgba(0, 0, 0, 0.05)",
        hover: "0 15px 35px rgba(0, 0, 0, 0.08)",
    },

    borderRadius: {
        small: "8px",
        medium: "12px",
        large: "16px",
        xlarge: "20px",
        round: "50%",
    },

    spacing: {
        xs: "4px",
        sm: "8px",
        md: "16px",
        lg: "24px",
        xl: "32px",
        xxl: "48px",
    },
};
